export default "__VITE_ASSET__DHwlkS$O__"